import { Stack, Typography, useMediaQuery } from "@mui/material";

import { BookOnboardingButton } from "components/Shipper/components/BookOnboardingButton";

import { BANNER_TEXT_MIN_WIDTH } from "../../constants";

export function UnverifiedShipperBanner() {
  const showText = useMediaQuery(BANNER_TEXT_MIN_WIDTH);

  return (
    <Stack direction="row" spacing={3} alignItems="center">
      {showText && (
        <Typography variant="h6" color="white" noWrap>
          Schedule a demo to start posting shipments
        </Typography>
      )}
      <BookOnboardingButton
        buttonSize="large"
        appearance="onDark"
        trackingSource="unverified_shipper_banner"
      />
    </Stack>
  );
}
